import { Kurs } from "./kurs";
//import { Kursteilnehmer } from "./teilnehmer";

export class Klassenbuch
{
  constructor(_datum: Date)
  {
    this.eintragsDatum = Klassenbuch.jsDatetoString(_datum);
  }
  klassenbuchNr: number;
  eintragsDatum: string;
  kurs: Kurs;
  thema: string = "";
  inhalte: string = "";
  trainer: string = "";
  static jsDatetoString(_datum?: Date): string
  {
    let d;
    if (_datum != undefined)
    {
      d = _datum;
    }
    else { d = new Date();}
    let m = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    if (day.length < 2)
    {
      day = "0" + day;
    }
    if (m.length < 2)
    {
      m = "0" + m;
    }
    return d.getFullYear() + "-" + m + "-" + day + "T00:00:00";
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/klassenbuch.ts